import React from "react";
import Spotlight from "./spotlight.jsx";
import ServiceCard from "./ServiceCard.jsx";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Onze diensten</h2>
          <p> Voltics biedt slimme oplossingen voor elektriciteit, domotica en netwerken, van installatie tot onderhoud.</p>
        </div>
        <Spotlight className="spotlight">
          <ServiceCard img="domotica" title="Domotica" description="Maak je woning slimmer en comfortabeler met automatisatie voor verlichting, verwarming en meer – volledig afgestemd op jouw levensstijl."/>
          <ServiceCard img="netwerk" title="Netwerkinstallaties" description="Van stabiele bekabeling tot snelle wifi, toegangscontrole en camerabewaking: wij zorgen voor een veilig en betrouwbaar netwerk."/>
          <ServiceCard img="elek" title="Elektriciteitswerken" description="Of het nu gaat om nieuwe installaties, uitbreidingen of herstellingen: wij leveren steeds veilige en kwalitatieve elektriciteitswerken."/>
        </Spotlight>
      </div>
    </div>
  );
};
